export default "__VITE_ASSET__BCno1gsR__"